import React from "react";
import "./ServiceOfferings.css";

export default function ServiceOfferings() {
  return (
    <div className="service-offerigns">
      <div className="container-fluid">k</div>
    </div>
  );
}
